// Render-time "now" helper.
//
// All dated rendering goes through `clockNow()` so the firm's ageing maths
// (SLAs, stale fact finds, "days since" labels) keeps moving after deploy
// rather than freezing on an anchored constant. Tests substitute the wall
// clock locally via fake timers — never a global mock — so individual
// snapshot/golden specs can pin their own moment without spilling state
// into unrelated suites.
export function clockNow(): Date {
    return new Date();
}
